// extracted by mini-css-extract-plugin
export default {"modal":"JU-z","error":"KU-z","disabled":"LU-z","fields":"MU-z","errorMsg":"NU-z","footer":"OU-z","formContentWrapper":"PU-z","productImage":"QU-z","overlay":"RU-z"};